import { useMediaQuery } from '@mui/material';
import { useMemo } from 'react';
import { messageLayoutTokens } from '../theme/message-layout';

/**
 * Responsive message spacing based on screen size
 * - Mobile (<768px): Base spacing (2px grouped, 8px ungrouped)
 * - Tablet (768-1023px): +1px
 * - Desktop (≥1024px): +2px
 */
export function useResponsiveMessageSpacing(hideAvatar: boolean): number {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)');

  return useMemo(() => {
    const { groupedMessages, ungroupedMessages } = messageLayoutTokens.spacing;
    const base = hideAvatar ? groupedMessages : ungroupedMessages;

    if (isMobile) return base;
    if (isTablet) return base + 1;
    return base + 2;
  }, [hideAvatar, isMobile, isTablet]);
}

/**
 * Check if device is mobile for touch-specific behaviors
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)');
}

/**
 * Minimum touch target size (WCAG requirement: 44x44px)
 */
export const TOUCH_TARGET_MIN_SIZE = 44;
